// extracted by mini-css-extract-plugin
module.exports = {"spinningImg":"jut__SpinningLoader__spinningImg","spin":"jut__SpinningLoader__spin"};